import { r as d, h as t } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const o = ".sc-archive-icon-h{display:flex}", s = o, i = class {
  constructor(e) {
    d(this, e), this.width = "15", this.height = "15";
  }
  render() {
    return t("svg", { key: "c90657137810712474546b7df924f325d768a09f", width: this.width, height: this.height, viewBox: "0 0 24 24", fill: "auto", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "861d7e33eb0db0b238cd562efe3d98d640a16dc2", d: "M3 6H5H21", stroke: "auto", "stroke-width": "1.5" }), t("path", { key: "85d1444119233db994bdc5857ff61b518771d844", d: "M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z", stroke: "auto", "stroke-width": "1.5" }), t("path", { key: "c43e382be1d60db694e2c988ec05d6be7a82354d", d: "M10 11V17", stroke: "auto", "stroke-width": "1.5" }), t("path", { key: "fb6520a7586db8bf3edddceaf668362e26efe665", d: "M14 11V17", stroke: "auto", "stroke-width": "1.5" }));
  }
};
i.style = s;
export {
  i as archive_icon
};
